import Flip from './flip';
import FlipItem from './flip-item';
var DefaultFlip = Flip;
DefaultFlip.Item = FlipItem;
export default DefaultFlip;
//# sourceMappingURL=index.js.map